import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Eyebrow from "@/components/Eyebrow";

export default function CTABlock({
  eyebrow = "Next Step",
  title = "Want a clearer picture of how your books are being handled?",
  body = "We'll walk through where things can be stronger, no pitch, no pressure.",
  ctaLabel = "Request a Financial Review",
  to = "/contact",
}) {
  return (
    <section className="relative bg-[#0C1D36] text-[#FDFBF7] noise overflow-hidden" data-testid="cta-block">
      <div className="container-editorial py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            {eyebrow && <Eyebrow className="text-white">{eyebrow}</Eyebrow>}
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6 max-w-3xl">
              {title}
            </h2>
            <p className="mt-6 text-base md:text-lg text-white/70 max-w-xl leading-relaxed">
              {body}
            </p>
          </div>
          <div className="md:col-span-4 flex md:justify-end">
            <Link
              to={to}
              className="btn-primary"
              data-testid="cta-block-button"
            >
              {ctaLabel}
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute left-0 right-0 top-0 h-px bg-[#BA1A1A]/70" />
    </section>
  );
}
